module.exports = __webpack_public_path__ + "img/wav.8df03bf8.png";